import type { SVGProps } from 'react';

export const DocumentFillSFSymbolRegular = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      height="1em"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 16.7871 20.9473"
      fill="currentColor"
      {...props}
    >
      <g>
        {' '}
        <rect height="20.9473" opacity="0" width="16.7871" x="0" y="0" />{' '}
        <path
          d="M3.02734 20.9375L13.3984 20.9375C15.4199 20.9375 16.4258 19.9121 16.4258 17.8809L16.4258 9.01367L9.35547 9.01367C8.10547 9.01367 7.50977 8.41797 7.50977 7.16797L7.50977 0L3.02734 0C1.01562 0 0 1.03516 0 3.06641L0 17.8809C0 19.9219 1.00586 20.9375 3.02734 20.9375ZM9.38477 7.67578L16.3086 7.67578C16.25 7.27539 15.9668 6.88477 15.498 6.40625L10.1172 0.927734C9.6582 0.458984 9.25781 0.175781 8.84766 0.107422L8.84766 7.14844C8.84766 7.5 9.02344 7.67578 9.38477 7.67578Z"
          fill="currentColor"
        />{' '}
      </g>
    </svg>
  );
};
